<template>
    <div class="row">
        <div class="col-md-4 mt-4">
            <div class="card border-0">
                <div class="row justify-content-center ">
                    <div class="col-md-12 pt-3">
                        <p class="font-weight-bold pl-3 mb-4 sb-block-title">My Supplements</p>
                    </div>
                </div>
                <div class="row justify-content-center ">
                    <div class="col-md-12">
                        <ul class="list-group mb-3" v-if="sups">
                            <li class="list-group-item border-top-0 border-right-0 border-left-0 ml-0 mr-0" v-for="s in sups">
                                <div class="row">
                                    <div class="col-md-7 sb-list-fitem-regular">
                                        {{ s.sup_sr ? s.sup_srname : s.supplement_data.sud_name }}
                                    </div>
                                    <div class="col-md-3 text-right sb-list-sitem">
                                        <a href="#" class="text-danger" @click="deleteSupById(s)">
                                            Remove
                                        </a>
                                    </div>
                                    <div class="col-md-2 text-right sb-list-sitem">
                                        <a href="#" class="color-sky-blue-3" @click.prevent="show(s)">
                                            Edit
                                        </a>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-8 mt-4">
            <div class="card border-0">
                <div class="row justify-content-center ">
                    <div class="col-md-12 pt-3">
                        <p class="font-weight-bold pl-3 mb-4 sb-block-title"><span v-if="update">Edit </span><span v-else>New </span>Supplement</p>
                    </div>
                </div>
                <div class="justify-content-center" v-if="update && sup.id==''">
                    <div class="col-md-12 text-center pb-3">
                        <h5 class="mt-5 mb-5">SELECT SUPPLEMENT TO EDIT</h5>
                    </div>
                </div>
                <div v-else class="justify-content-center">
                    <div class="col-md-12">
                        <div id="sup-form">
                            <div class="form-group">
                                <label class="mb-0">What is your new supplement?</label>
                                <small class="form-text text-muted mb-2">Entering the first few letters of your new supplement will display a suggestion.</small>
                                <multiselect
                                        v-model="sup.sup_sud"
                                        track-by="sud_id"
                                        label="sud_name"
                                        placeholder="Select one"
                                        :searchable="true"
                                        :allow-empty="false"
                                        :options="supplements"
                                        :taggable="true"
                                        @tag="addSrSup"
                                        tag-placeholder="Add new supplement"
                                >
                                    <template slot="noOptions">Please type to search</template>
                                </multiselect>
                                <div class="form-group">
                                    <input type="hidden" name="sup_sudid">
                                    <input type="hidden" name="sup_srname">
                                </div>
                            </div>
                        </div>
                        <div class="text-right mb-3">
                            <button v-if="!update" type="button" class="btn btn-success" @click.prevent="saveSup">Add to My Supplements</button>
                            <button v-if="update" type="button" class="btn btn-success" @click.prevent="updateSup">Update My Supplement</button>
                            <br/>
                            <a href="/my-health" type="button" class="btn btn-outline-secondary mt-3">Cancel</a>
                        </div>

                    </div>
                </div>
            </div>
        </div>
 </div>
</template>

<script>
export default {
    props: ['supplements', 'methodtype'],
    mounted() {
        this.listSup();
        this.addScreenReaderLabelsToMultiSelects();
        this.update = this.methodtype !== 'add';
    },
    data() {
        return {
            route: '/api/supplements',
            update: false,
            sup: {
                id: null,
                sup_sud: {sud_id: null},
                sup_sudid: null,
                sup_srname: null,
            },
            sups: []
        }
    },
    methods: {
        addSrSup(tag) {
            this.sup.sup_srname = tag;
            this.sup.sup_sud = {
                sud_name: tag,
                sud_id: 0
            };
        },
        saveSup() {
            //null safe injection
            if (this.sup.sup_sud == null) {
                this.sup.sup_sud = {sud_id: null}
            }

            this._clearErrors();

            this.$http.post(this.route, {
                sup_sudid: this.sup.sup_sud.sud_id,
                sup_srname: this.sup.sup_srname,
            })
                .then(function (response) {
                    this.listSup();
                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        text: 'Supplement was created!'
                    });
                    this.sup = {
                        id: null,
                        sup_sud: null,
                        sup_sudid: null,
                    }
                }, (response) => {
                    this._handleErrors(response.data, '#sup-form')
                })
        },
        listSup() {
            this.$http.get(this.route)
                .then(function (response) {
                    this.sups = response.data;
                    if(this.sups.length > 0 && this.update) this.show(this.sups[0])
                }, (response) => {
                    this._handleErrors(response.data, '#sup-form')
                })
        },
        show(s) {
            this.update = true
            this.sup = {
                id: s.sup_id,
                sup_sud: {
                    sud_id: s.sup_sr ? 0 : s.sup_sudid,
                    sud_name: s.sup_sr ? s.sup_srname : s.supplement_data.sud_name,
                },
                sup_sudid: s.sup_sudid,
            };
        },
        updateSup() {
            //null safe injection
            if (this.sup.sup_sud == null) {
                this.sup.sup_sud = {sud_id: null}
            }

            this._clearErrors();

            this.$http.put(this.route, {
                sup_id: this.sup.id,
                sup_sudid: this.sup.sup_sud.sud_id,
                sup_srname: this.sup.sup_srname,
            })
                .then(function (response) {
                    this.listSup();
                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        text: 'Supplement was updated!'
                    });
                }, (response) => {
                    this._handleErrors(response.data, '#sup-form')
                })
        },
        deleteSupById(sup) {
            if (!confirm('Do you really want to delete this supplement?'))
                return

            this.$http.delete(this.route + '/' + sup.sup_id, sup)
                .then(function (response) {
                    this.listSup();
                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        text: 'Supplement was deleted!'
                    });
                }, (response) => {
                    this._handleErrors(response.data, '#sup-form')
                })
        },
        _handleErrors: function (items, selector) {
            this._clearErrors();
            for (var error in items['errors']) {
                if (items['errors'].hasOwnProperty(error)) {
                    if (error === 'sup_sudid' && items['errors'].hasOwnProperty('sup_srname')) {
                        //both checks failed validation on backend, but we only need to display one
                        //because they are duplicate messages.
                        continue;
                    }
                    var text = error;
                    var parts = text.split('.');
                    var name = parts.pop();
                    var el = $(selector + ' [name="' + name + '"]')
                    el.closest('.form-group').addClass('has-error')
                    $('<p class="help-block">' + (items['errors'][error].join(', ')) + '</p>').insertAfter(selector + ' [name="' + name + '"]');
                }
            }
        },
        _clearErrors: function () {
            $('.has-error').removeClass('has-error')
            $('.help-block').remove()
        },
        addScreenReaderLabelsToMultiSelects() {
            $('.multiselect__tags:first').attr('aria-label', 'Search For Supplement');
        }
    }

}
</script>
